module.exports = __webpack_public_path__ + "media/recipes/132-f0eb6d22.png";